import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Input } from 'ui';
import { Form } from 'antd';
import { useIntl } from 'react-intl';
import { StyledSearch } from './style';

export interface SearchProps {
  placeholder?: string;
  required?: boolean;
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
  type?: string;
  disabled?: boolean;
  size?: 'large' | 'middle' | 'small';
  value?: string;
  onSearch?: (t: string) => void;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  defaultValue?: string;
  label?: string;
  onClick?: React.MouseEventHandler<HTMLInputElement>;
  onBlur?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isReset?: boolean;
  isPlaceholder?: boolean;
}

export const Search = ({
  disabled,
  placeholder,
  required,
  prefix,
  suffix,
  type,
  size,
  value,
  onSearch,
  onChange,
  defaultValue,
  label,
  onClick,
  onBlur,
  isReset,
  isPlaceholder = true,
}: SearchProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const intl = useIntl();
  const [searchForm] = Form.useForm();

  const PRODUCT_PATHS = [
    '/products/all',
  ]

  const updateSearchQuery = (search: string | null) => {
    const params = new URLSearchParams(location.search);
    if (search) {
      params.set('search', search);
    } else {
      params.delete('search');
    }

    if (PRODUCT_PATHS.includes(location.pathname)) {
      navigate(`?${params.toString()}`);
    } else {
      navigate(`/products/all?${params.toString()}`);
    }
  }

  const onFinish = () => {
    const { search } = searchForm.getFieldsValue();
    updateSearchQuery(search);
    !!onSearch && !!search && onSearch(search);
  };

  if (isReset) {
    searchForm.resetFields();
  }

  useEffect(() => {
    if (value) {
      searchForm.setFieldValue('search', value);
    } else {
      const params = new URLSearchParams(location.search);
      const q = params.get('search');

      if (q) {
        searchForm.setFieldValue('search', q);
      } else {
        searchForm.resetFields();
      }
    }
  }, [value, location.search]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <StyledSearch onClick={onClick}>
      <Form
        onFinish={onFinish}
        form={searchForm}
        name="search-form"
        layout="vertical"
        className={'flex-grow'}
      >
        <Form.Item name="search" noStyle>
          <Input
            disabled={disabled}
            placeholder={
              isPlaceholder
                ? !!placeholder
                  ? placeholder
                  : intl.formatMessage({
                      id: 'general.search',
                    })
                : ''
            }
            required={required}
            prefix={prefix}
            suffix={suffix}
            type={type}
            size={size}
            allowClear
            onClear={() => updateSearchQuery(null)}
            onChange={onChange}
            defaultValue={defaultValue}
            label={label}
            onBlur={onBlur}
          />
        </Form.Item>
      </Form>
    </StyledSearch>
  );
};
